<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>Du er her:</p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.lexin-exam') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language></Language>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.lexin-exam') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info">
            <h2><b>{{$t('message.whitelisting_text1')}}</b></h2>
            <p>{{$t('message.whitelisting_text2')}}</p>
            <p>https://lexin.oslomet.no</p>
            <p>https://editorportal.oslomet.no</p>
            <p>https://speech.leseweb.dk</p>
            <p>https://rawfiles.leseweb.dk</p>
            <p>https://fonts.googleapis.com</p>
            <p>https://cacerts.digicert.com</p>
            <p>https://speech1.leseweb.dk</p>
            <p>https://speech2.leseweb.dk</p>
            <p>https://speech3.leseweb.dk</p>
            <p>https://speech4.leseweb.dk</p>
            <p>https://speech5.leseweb.dk</p>
            <p>https://speech6.leseweb.dk</p>
            <p>https://speech7.leseweb.dk</p>
            <p>https://speech8.leseweb.dk</p>
            <p>https://speech9.leseweb.dk</p>
            <p>https://speech10.leseweb.dk</p>
            <p>https://speech11.leseweb.dk</p>
            <p>https://speech12.leseweb.dk</p>
            <p>https://speech13.leseweb.dk</p>
            <p>https://speech14.leseweb.dk</p>
            <p>https://speech15.leseweb.dk</p>
            <p>https://speech16.leseweb.dk</p>
            <p>https://speech17.leseweb.dk</p>
            <p>https://speech18.leseweb.dk</p>
            <p>https://speech19.leseweb.dk</p>
            <p>https://speech20.leseweb.dk</p>
            <p>https://speech21.leseweb.dk</p>
            <p>https://speech22.leseweb.dk</p>
            <p>https://oslomet.matomo.cloud</p>
            <p>https://cdn.matomo.cloud</p>
            <p class="mt-4">{{$t('message.whitelisting_text3')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Language from "./Language.vue";
export default {
  name: "DomainListComponent",
  data() {
    return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  components: {
    Language
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>
